// extracted by mini-css-extract-plugin
export default {"ref":"AboutUs_dev_ref__pgyZ3","content":"AboutUs_dev_content__12J8C"};